import React from 'react';
import { safeHTML } from '../../../utils/safeHTML';

const Level = React.forwardRef(function Level({ description }, ref) {
  return <h2 className={'w-modal__level'}>{safeHTML(description)}</h2>;
});
export default Level;
Level.propTypes = {};
